"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserRole = void 0;
const getUserRole = (user, roles) => {
  const roleNames = user.roleIds.map(roleId => {
    var _roles$roleId;
    return (_roles$roleId = roles[roleId]) === null || _roles$roleId === void 0 ? void 0 : _roles$roleId.name;
  }).filter(name => !!name);
  if (roleNames.length === 0) {
    return "";
  }
  if (roleNames.length === 1) {
    return roleNames[0];
  }
  return roleNames;
};
exports.getUserRole = getUserRole;
//# sourceMappingURL=getUserRole.js.map